import { render } from "./Publish.vue?vue&type=template&id=b1f432e2&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"

import "./Publish.vue?vue&type=style&index=0&id=b1f432e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f432e2"]])

export default __exports__